import { PortDataDirection } from "shared-ui-components/nodeGraphSystem/interfaces/portData.js";
import { TypeLedger } from "shared-ui-components/nodeGraphSystem/typeLedger.js";
import { getCompatibilityIssueMessage, ConnectionPointDirection } from "smart-filters";
export class ConnectionPointPortData {
    get name() {
        const block = this.data.ownerBlock;
        let portName = this.data.displayName || this.data.name;
        if (this.data.ownerBlock.isInput) {
            portName = block.name;
        }
        return portName;
    }
    get internalName() {
        return this.data.name;
    }
    get isExposedOnFrame() {
        // return this.data.isExposedOnFrame;
        return false;
    }
    set isExposedOnFrame(_value) {
        // this.data.isExposedOnFrame = value;
    }
    get exposedPortPosition() {
        // return this.data.exposedPortPosition;
        return -1;
    }
    set exposedPortPosition(_value) {
        // this.data.exposedPortPosition = value;
    }
    get isConnected() {
        // return this.data.isConnected;
        return this.data.connectedTo !== null || this.hasEndpoints;
    }
    get isInactive() {
        return false;
    }
    get connectedPort() {
        if (!this.isConnected) {
            return null;
        }
        if (!this._connectedPort) {
            const otherBlock = this.data.connectedTo.ownerBlock;
            let otherNode = this._nodeContainer.nodes.find((n) => n.content.data === otherBlock);
            if (!otherNode) {
                otherNode = this._nodeContainer.appendNode(TypeLedger.NodeDataBuilder(otherBlock, this._nodeContainer));
            }
            this._connectedPort = otherNode.getPortDataForPortDataContent(this.data.connectedTo);
        }
        return this._connectedPort;
    }
    set connectedPort(value) {
        this._connectedPort = value;
    }
    get direction() {
        switch (this.data.direction) {
            case ConnectionPointDirection.Input:
                return PortDataDirection.Input;
            default:
                return PortDataDirection.Output;
        }
    }
    get ownerData() {
        return this.data.ownerBlock;
    }
    get needDualDirectionValidation() {
        // return this.data.needDualDirectionValidation;
        return false;
    }
    get hasEndpoints() {
        // return this.data.hasEndpoints;
        return this.data.endpoints.length > 0;
    }
    get endpoints() {
        const endpoints = [];
        this.data.endpoints.forEach((endpoint) => {
            const endpointOwnerBlock = endpoint.ownerBlock;
            const endpointNode = this._nodeContainer.nodes.find((n) => n.content.data === endpointOwnerBlock);
            endpoints.push(endpointNode.getPortDataForPortDataContent(endpoint));
        });
        return endpoints;
    }
    constructor(connectionPoint, nodeContainer) {
        this._connectedPort = null;
        this.data = connectionPoint;
        this._nodeContainer = nodeContainer;
    }
    updateDisplayName(newName) {
        this.data.displayName = newName;
    }
    connectTo(port) {
        this.data.connectTo(port.data);
        this._connectedPort = port;
    }
    canConnectTo(port) {
        return this.data.canConnectTo(port.data);
    }
    disconnectFrom(port) {
        this.data.disconnectFrom(port.data);
        port.data.runtimeData = port.data.defaultRuntimeData;
        port.connectedPort = null;
    }
    checkCompatibilityState(port) {
        return this.data.checkCompatibilityState(port.data);
    }
    getCompatibilityIssueMessage(issue, _targetNode, _targetPort) {
        return getCompatibilityIssueMessage(issue);
    }
}
//# sourceMappingURL=connectionPointPortData.js.map